"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WS_PUT_ACTIVITY = exports.WS_POST_ACTIVITY = exports.WS_DELETE_ACTIVITY = exports.SET_CURRENT_PAGE = exports.SET_ACTIVITIES_LOADED = exports.REMOVE_ACTIVITY_FROM_ENTITIES = exports.GET_NEW_PAGE_OF_ACTIVITIES = exports.EDIT_ACTIVITY = exports.DISABLE_INFINITE_ACTIVITY_INDICATOR = exports.DELETE_ACTIVITY = exports.CREATE_NEW_ACTIVITY = void 0;
var CREATE_NEW_ACTIVITY = exports.CREATE_NEW_ACTIVITY = 'CREATE_NEW_ACTIVITY';
var DELETE_ACTIVITY = exports.DELETE_ACTIVITY = 'DELETE_ACTIVITY';
var DISABLE_INFINITE_ACTIVITY_INDICATOR = exports.DISABLE_INFINITE_ACTIVITY_INDICATOR = 'DISABLE_INFINITE_ACTIVITY_INDICATOR';
var EDIT_ACTIVITY = exports.EDIT_ACTIVITY = 'EDIT_ACTIVITY';
var GET_NEW_PAGE_OF_ACTIVITIES = exports.GET_NEW_PAGE_OF_ACTIVITIES = 'GET_NEW_PAGE_OF_ACTIVITIES';
var REMOVE_ACTIVITY_FROM_ENTITIES = exports.REMOVE_ACTIVITY_FROM_ENTITIES = 'REMOVE_ACTIVITY_FROM_ENTITIES';
var SET_ACTIVITIES_LOADED = exports.SET_ACTIVITIES_LOADED = 'SET_ACTIVITIES_LOADED';
var SET_CURRENT_PAGE = exports.SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
var WS_DELETE_ACTIVITY = exports.WS_DELETE_ACTIVITY = 'WS_DELETE_ACTIVITY';
var WS_POST_ACTIVITY = exports.WS_POST_ACTIVITY = 'WS_POST_ACTIVITY';
var WS_PUT_ACTIVITY = exports.WS_PUT_ACTIVITY = 'WS_PUT_ACTIVITY';
var _default = exports.default = {
  CREATE_NEW_ACTIVITY,
  DELETE_ACTIVITY,
  DISABLE_INFINITE_ACTIVITY_INDICATOR,
  EDIT_ACTIVITY,
  GET_NEW_PAGE_OF_ACTIVITIES,
  REMOVE_ACTIVITY_FROM_ENTITIES,
  SET_ACTIVITIES_LOADED,
  SET_CURRENT_PAGE,
  WS_DELETE_ACTIVITY,
  WS_POST_ACTIVITY,
  WS_PUT_ACTIVITY
};